import React from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="w-full bg-gradient-to-b from-white to-blue-50 pt-8 pb-16 md:pt-16 md:pb-24" data-id="element-245">
      <div className="max-w-5xl mx-auto px-6" data-id="element-246">
        {/* Badge */}
        <div className="flex justify-center mb-8" data-id="element-247">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 text-[#0866FF] rounded-full text-sm font-medium" data-id="element-248">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-249">
              <path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z" data-id="element-250" />
            </svg>
            Curso en Vivo para Principiantes
          </span>
        </div>

        {/* Main Headline */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-center text-gray-900 leading-tight mb-6" data-id="element-251">
          Aprende Meta Ads Desde Cero y Lanza Tus Primeras{' '}
          <span className="text-[#0866FF]" data-id="element-252">Campañas Rentables</span> en Solo
          Unas Semanas
        </h1>

        {/* Subheadline */}
        <p className="text-xl md:text-2xl text-center text-gray-600 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-253">
          Curso en vivo para principiantes donde creas tus campañas paso a paso,
          sin tecnicismos y sin miedo a "tocar algo y romper todo".
        </p>

        {/* CTA */}
        <div className="flex justify-center mb-12" data-id="element-254">
          <CTAButton size="large" scrollTo="pricing" data-id="element-255">
            Quiero Aprender Meta Ads →
          </CTAButton>
        </div>

        {/* Hero Image */}
        <div className="relative max-w-4xl mx-auto" data-id="element-256">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-2xl blur-3xl -z-10" data-id="element-257"></div>
          <img src="https://cdn.magicpatterns.com/uploads/fvwaSLTwpwZz9GystuBcoV/ChatGPT_Image_3_dic_2025,_10_46_37_p.m..png" alt="Meta Ads Desde Cero - Curso en vivo para principiantes" className="w-full rounded-2xl shadow-2xl" data-id="element-258" />
        </div>
      </div>
    </section>;
}